module.exports = __webpack_public_path__ + "img/avatar.ae96ed19.svg";